import { client } from "venuescanner-js/services/socketClient";
import consume from "./models/consume";

const call = ({ inboxService, states }) => {
  /**
 * @typedef {Object} call - The observable Call Object
* @property {string} call._id - The Call Id
* @property {string} call.callReportCode - The reported code
* @property {number} call.callDuration - The duration is seconds
* @property {string} call.callerName - The caller's name
* @property {string} call.originalCallNumber - The caller's phone number
* @property {string} call.callerRole - The Role of the Caller
* @property {string} call.receiverName - The receiver's name
* @property {string} call.receivingCallNumber - The receiver's phone number
* @property {string} call.receiverRole - The receiver's Role
* @property {string} call.callMsgStat - The msgStat
* @property {boolean} call.callFinished - Has the call finished
* @property {boolean} call.callSuccess - Was the call successful

 */
  return {
    /** @function
     * @async
     * @name call.start
     * @desc Returns a call Object
     * @memberof! module:inboxService
     * @param options {object}
     * @param {String} options.threadId - The thread ID to start the call from
     * @param {String} [options.number] - The prefered number to make the call with
     * @returns {call}
     */
    start: async function ({ threadId, number }) {
      const { call } = await client.sendPromise("room", {
        startCall: { threadId, number },
      });

      // console.log({ call })

      return consume("call", call);
    },
  };
};
export default call;
